import React from 'react';
import { Button, Box, CircularProgress } from '@mui/material';

export default function CupomFeedbackForm({ formData, onChange, onSubmit, loading }) {
    return (
        <Box component="form" onSubmit={onSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
        {['nome', 'email', 'mensagem'].map((field) => (
            field !== 'mensagem' ? (
            <input
                key={field}
                name={field}
                type={field === 'email' ? 'email' : 'text'}
                placeholder={`Seu ${field}`}
                value={formData[field]}
                onChange={onChange}
                required
                style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc' }}
            />
            ) : (
            <textarea
                key={field}
                name={field}
                placeholder="Escreva sua mensagem"
                value={formData[field]}
                onChange={onChange}
                required
                style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc', resize: 'vertical' }}
                rows={4}
            />
            )
        ))}
        <Button type="submit" variant="contained" sx={{ borderRadius: 2, fontWeight: 'bold', width: { xs: '80%', sm: 150, md: 300 }, m: '0 auto' }}>
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Enviar'}
        </Button>
        </Box>
    );
}
